import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { PAYMENT_REQUIRED_EVENT } from '@/lib/axios'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens'

export function PaymentRequiredDialog() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handlePaymentRequired = () => {
      setOpen(true)
    }

    window.addEventListener(PAYMENT_REQUIRED_EVENT, handlePaymentRequired)

    return () => {
      window.removeEventListener(PAYMENT_REQUIRED_EVENT, handlePaymentRequired)
    }
  }, [])

  const handleViewPlan = () => {
    window.location.href = '/settings/usage'
  }

  return (
    <Dialog open={open} onOpenChange={(value) => {
      setOpen(value);
      if (!value) {
        window.location.reload();
      }
    }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t(tokens.settings.billing.plan_attention.title)}</DialogTitle>
          <DialogDescription>
            {t(tokens.settings.billing.plan_attention.description)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleViewPlan}>{t(tokens.settings.billing.plan_attention.cta)}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default PaymentRequiredDialog 